var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.96875 6.46875L6.9375 0.75C7.125 0.59375 7.3125 0.5 7.5 0.5C7.6875 0.5 7.84375 0.5625 8 0.6875L13.9688 6.40625C14.2812 6.71875 14.2812 7.1875 14 7.46875C13.7188 7.78125 13.25 7.78125 12.9375 7.5L7.5 2.3125L2 7.5625C1.71875 7.84375 1.21875 7.84375 0.9375 7.53125C0.65625 7.21875 0.65625 6.75 0.96875 6.46875Z",
    fill: "#989CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyUpIcon);
export default __webpack_public_path__ + "static/media/KeyUpIcon.a6a57513a66ef0109c2410e74d61d2b5.svg";
export { ForwardRef as ReactComponent };